<div class="widget" [class.kpi]="element.widgetType !== 'kpiTable'" [class.kpi-table]="element.widgetType === 'kpiTable'"
     [class.editing]="editing" (click)="open($event)" [title]="editing ? '' : 'Open ' + element.name">
  <div class="widget-header">
    <div class="widget-title">{{element.name}}</div>
    <div *ngIf="today && element.widgetType !== 'kpiTable'" class="widget-window">{{today.label}}</div>
  </div>

  <div *ngIf="loading" class="widget-state">Loading…</div>
  <div *ngIf="!loading && error" class="widget-state error">{{error}}</div>

  <ng-container *ngIf="!loading && !error && widget">

    <!-- KPI card: hero figure for today, signed change vs yesterday, a
         sparkline of the recent days, the other metrics, month to date. -->
    <ng-container *ngIf="element.widgetType !== 'kpiTable'">
      <div class="hero">
        <div class="hero-value">{{value(today, primaryMetric) | rf:primaryMetric?.type}}</div>
        <div class="hero-label">{{primaryMetric?.name}}</div>
      </div>
      <div *ngIf="delta" class="delta" [class.up]="delta.direction === 'up'" [class.down]="delta.direction === 'down'" [class.flat]="delta.direction === 'flat'">
        <span class="delta-arrow" aria-hidden="true">{{delta.direction === 'up' ? '▲' : (delta.direction === 'down' ? '▼' : '•')}}</span>
        <span class="delta-value">{{(delta.change < 0 ? -delta.change : delta.change) | rf:primaryMetric?.type}}</span>
        <span *ngIf="delta.percent != null" class="delta-pct">({{(delta.percent < 0 ? -delta.percent : delta.percent) * 100 | number:'1.0-0'}}%)</span>
        <span class="delta-label">{{delta.label}}</span>
      </div>

      <div *ngIf="sparkPoints.length" class="spark" [title]="sparkTitle">
        <svg [attr.viewBox]="'0 0 ' + sparkWidth + ' ' + sparkHeight" preserveAspectRatio="none" role="img" [attr.aria-label]="sparkTitle">
          <polyline class="spark-line" [attr.points]="sparkPath" />
          <circle *ngIf="sparkLast" class="spark-dot" [attr.cx]="sparkLast.x" [attr.cy]="sparkLast.y" r="2.4" />
        </svg>
        <div class="spark-caption">{{trend.length}}-day trend</div>
      </div>

      <div class="secondary">
        <div *ngFor="let metric of secondaryMetrics" class="secondary-metric">
          <div class="secondary-value">{{value(today, metric) | rf:metric.type}}</div>
          <div class="secondary-label">{{metric.name}}</div>
        </div>
      </div>

      <div *ngIf="monthToDate" class="window-row">
        <div class="window-label">{{monthToDate.label}}</div>
        <div *ngFor="let metric of widget.metrics" class="window-metric">
          <span class="window-value">{{value(monthToDate, metric) | rf:metric.type}}</span>
          <span class="window-name">{{metric.name}}</span>
        </div>
      </div>
    </ng-container>

    <!-- KPI table: one row per location, today and month to date side by side,
         with each location's share of month-to-date sales as an inline bar. -->
    <ng-container *ngIf="element.widgetType === 'kpiTable'">
      <table class="kpi-rows">
        <thead>
          <tr>
            <th class="loc"></th>
            <th class="group" [attr.colspan]="secondaryMetrics.length + 1">{{today?.label || 'Today'}}</th>
            <th class="group mtd" [attr.colspan]="secondaryMetrics.length + 1">{{monthToDate?.label || 'Month to Date'}}</th>
          </tr>
          <tr>
            <th class="loc">Location</th>
            <th *ngFor="let metric of widget.metrics" class="num" [ngClass]="'m-' + metric.path">{{metric.name}}</th>
            <th *ngFor="let metric of widget.metrics" class="num mtd" [ngClass]="'m-' + metric.path">{{metric.name}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tableRows">
            <td class="loc">
              {{row.locationName}}
              <span class="share" [title]="(row.share * 100 | number:'1.0-0') + '% of ' + (monthToDate?.label || 'month to date') + ' ' + (primaryMetric?.name || '')">
                <span class="share-fill" [style.width.%]="row.share * 100"></span>
              </span>
            </td>
            <td *ngFor="let metric of widget.metrics" class="num" [ngClass]="'m-' + metric.path">{{value(null, metric, row.today) | rf:metric.type}}</td>
            <td *ngFor="let metric of widget.metrics" class="num mtd" [ngClass]="'m-' + metric.path">{{value(null, metric, row.monthToDate) | rf:metric.type}}</td>
          </tr>
          <tr *ngIf="tableRows.length === 0">
            <td class="loc empty" [attr.colspan]="widget.metrics.length * 2 + 1">No sales in this range.</td>
          </tr>
          <tr *ngIf="tableRows.length > 1" class="total">
            <td class="loc">All</td>
            <td *ngFor="let metric of widget.metrics" class="num" [ngClass]="'m-' + metric.path">{{value(today, metric) | rf:metric.type}}</td>
            <td *ngFor="let metric of widget.metrics" class="num mtd" [ngClass]="'m-' + metric.path">{{value(monthToDate, metric) | rf:metric.type}}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>

  </ng-container>
</div>
